import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminService } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminServicesService {
  private baseUrl = `${environment.apiBaseUrl}/admin/services`;

  constructor(private http: HttpClient) {}

  getServices(): Observable<PaginatedResponse<AdminService>> {
    return this.http.get<any>(`${environment.apiBaseUrl}/services`).pipe(
      map(res => res.data ?? res)
    );
  }

  createService(data: Partial<AdminService>): Observable<AdminService> {
    return this.http.post<ApiResponse<AdminService>>(this.baseUrl, data).pipe(
      map(res => res.data)
    );
  }

  updateService(id: number, data: Partial<AdminService>): Observable<AdminService> {
    return this.http.put<ApiResponse<AdminService>>(`${this.baseUrl}/${id}`, data).pipe(
      map(res => res.data)
    );
  }

  deleteService(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
